import { Page, Container, ContentHeader } from 'components'
import { PlansForm } from './components'

const PlansNew = () => {
  return (
    <Page title="Novo plano de integração">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          title="Novo"
          menu="Plano de integração"
          subtitle="Plano de integração"
        />
        <PlansForm />
      </Container>
    </Page>
  )
}
export default PlansNew
